<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h1>404</h1>
      <h2>Page not found</h2>
    </div>
    <a (click)="back()">Go Back</a>
  </div>
</div>